import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

export const MUTATION = graphql(`
  mutation UpdateTable($id: ID!, $data: UpdateTable!) {
    updateTable(id: $id, data: $data) {
      name
      seats
    }
  }
`);

export function useUpdateTable() {
  return useMutation(MUTATION, {
    refetchQueries: ['tableGroup'],
  });
}
